import React, { useState } from "react";
import axios from "axios";
import {
    baseURL
} from "../../../../constants/applicationConstants.js";
import PreviewCardView from './previewCard.jsx'
import swal from "sweetalert";
import { encrypt } from '../../../../shared/helper'
import { useHistory } from "react-router-dom";
import { Loader } from "../../loader/loader.jsx";

const PreviewCard = () => {
    const history = useHistory();

    const [option, setOption] = useState("de-select");
    const [isLoading, setIsLoading] = useState(false);

    const cardDetails = JSON.parse(localStorage.getItem("addCard"))
    const onselectTypeButtonClick = (select) => {
        setOption(select)
    }

    const formSubmitHandler = (e) => {
        setIsLoading(true)

        let instituteId = JSON.parse(localStorage.getItem("instituteId"));
        let isResume = localStorage.getItem("resumeOnBoard")
        let tokenValidate = JSON.parse(localStorage.getItem("token"));
        let subscriptionPlanTypeId = JSON.parse(localStorage.getItem("planTypeID"));
        let subscriptionPlanId = JSON.parse(localStorage.getItem("subscriptionPlanId"));
        let expertId = localStorage.getItem("expertId") && JSON.parse(localStorage.getItem("expertId"))
        const adminToken = localStorage.getItem('adminOldToken');

        e.preventDefault();
        let data = {
            instituteId: instituteId,
            subscriptionPlanTypeId: subscriptionPlanTypeId,
            tokenValidate: tokenValidate,
            cardNumber: cardDetails.card,
            expiryMonth: encrypt(cardDetails.month.toString()),
            expiryYear: encrypt(cardDetails.year),
            cvc: cardDetails.cvc,
        };
        if (expertId) {
            delete data.instituteId;
            data.expertId = expertId
        }

        let flowName = localStorage.getItem('AdminFlow');
        let subURL = '';
        if (flowName === 'institute' || flowName === 'expert') {
            subURL = '/paidByAdmin'
        }
        // /institute/:instituteId/resume-onboarding
        axios.post(`  ${baseURL}/subscriptionPlan/${subscriptionPlanId}${subURL}`, data).then((res) => {
            setIsLoading(false)
            if (res) {
                localStorage.removeItem("expertId");
                localStorage.removeItem("description");
                localStorage.removeItem("expertData");
                localStorage.removeItem("subscriptionPlanId");
                localStorage.removeItem("planTypeID");
                localStorage.removeItem("planData");
                localStorage.removeItem("addCard");
            }

            if (isResume) {
                let comingFromInstitute = localStorage.getItem("comingFromInstitute")
                if (comingFromInstitute && comingFromInstitute) {
                    localStorage.removeItem("resumeOnBoard");
                    localStorage.removeItem("isRemoveState")

                    let oldToken = localStorage.getItem("instituteExpertToken")
                    localStorage.setItem("token", oldToken);
                } else {
                    localStorage.removeItem("resumeOnBoard");
                    localStorage.removeItem("isRemoveState")

                    localStorage.setItem("token", JSON.stringify(adminToken));
                }


            }

            localStorage.setItem('paymentData', JSON.stringify(res.data.data))

            history.push("/paymentSummery");
        }).catch((res) => {
            setIsLoading(false)

            swal({
                title: "error",
                text: res?.response.data.error.message,
                icon: "error",
            });


        })

    };

    return (
        <>
            <PreviewCardView
                cardDetails={cardDetails}
                onselectTypeButtonClick={onselectTypeButtonClick}
                option={option}
                formSubmitHandler={formSubmitHandler}
            />
            {isLoading && <Loader />}

        </>
    )
}

export default PreviewCard;